export const DisabledItemTheme = {
  Hidden: "hidden",
  Locked: "locked"
};

export const GamificationTheme = {
  Ambassador: "gamification.ambassador",
  Gamification: "gamification.pageTitle",
};
